import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import TaskFromTemplateForm from './TaskFromTemplateForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Company } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTaskFromTemplate',
  props: {
    company: {}
  },
  setup(__props: any) {

    const props = __props;

    const form = useForm({
        selected_template: '',
        tasks_deadline: '',
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.dashboard.tasks.create.from-template'),
    "query-key": [_unref(QueryKey).DASHBOARD_TASKS, props.company.id],
    title: "dashboards.tasks_add_from_template",
    "button-text": "dashboards.tasks_create_from_template",
    "submit-text": "dashboards.tasks_create"
  }, {
    default: _withCtx(() => [
      _createVNode(TaskFromTemplateForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})